import { render, staticRenderFns } from "./drawer-info.vue?vue&type=template&id=2ccbdc4c&"
import script from "./drawer-info.vue?vue&type=script&lang=js&"
export * from "./drawer-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports